import {useCallback, useRef, useState} from 'react';

import {assignSeatToUser} from 'src/openapi/admin/apis/UserSeatAssignmentsApi';
import {SeatAssignRequestState} from 'src/openapi/admin/models/SeatAssignRequest';
import {useAppDispatch} from 'src/store/hooks';
import {getError} from 'src/utils/get-error';

export const useAssignSeatToUser = (userId: number) => {
    const apiDispatch = useAppDispatch();
    const [assigning, setAssigning] = useState(false);
    const [error, setError] = useState('');
    const isRequestPending = useRef(false);

    const assign = useCallback(async (productSubscriptionId: string) => {
        if (isRequestPending.current) {
            return false;
        }

        isRequestPending.current = true;
        setAssigning(true);
        setError('');

        try {
            const response = await apiDispatch(assignSeatToUser({
                userId,
                seatAssignRequest: {state: SeatAssignRequestState.ASSIGN, productSubscriptionId},
            }));

            if (response.payload?.success) {
                return true;
            }

            setError(getError({error: response.payload?.data, separator: '. '}));
            return false;
        } finally {
            isRequestPending.current = false;
            setAssigning(false);
        }
    }, [apiDispatch, userId]);

    return {assign, assigning, error};
};
